// Copyright 2025 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.
export * from "./dataTypes/dcatDataTypes.js";
export * from "./models/dcatClasses.js";
export * from "./models/dcatContexts.js";
export * from "./models/dcatContextType.js";
export * from "./models/dcatRelationshipTypes.js";
export * from "./models/IDcatCatalog.js";
export * from "./models/IDcatCatalogBase.js";
export * from "./models/IDcatCatalogRecord.js";
export * from "./models/IDcatCatalogRecordBase.js";
export * from "./models/IDcatDataService.js";
export * from "./models/IDcatDataServiceBase.js";
export * from "./models/IDcatDataset.js";
export * from "./models/IDcatDatasetBase.js";
export * from "./models/IDcatDatasetSeries.js";
export * from "./models/IDcatDistribution.js";
export * from "./models/IDcatDistributionBase.js";
export * from "./models/IDcatRelationship.js";
export * from "./models/IDcatResource.js";
export * from "./models/IDcatResourceBase.js";
export * from "./models/IDcatRole.js";
